module.exports = __webpack_public_path__ + "media/images/wines/tempranillo-rosado/bottle-detail-4b552137bea0f36823aed4517fa11c9a.png";